import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
    api_base_url,
    auth0_app_client_id,
    auth0_redirected_endpoint,
    cloudfront_base_url,
    cognito_app_client_id,
    social_api_base_url,
    web_base_url,
} from "../../config/config";
import { userData } from "../../config/sessionKeys";
import { returnNumberByLang } from "../../helper/CommonFunctions";
import ApiUrlServices from "../../networks/ApiUrlServices";
import AxiosServices from "../../networks/AxiosService";
import Login from "../../pages/auth/login/Login";
import path from "../../routes/path";
import { bookCartAction } from "../../store/bookCartSlice";
import { cartAction } from "../../store/cartSlice";
import { courseAction } from "../../store/courseSlice";
import { userAction } from "../../store/userSlice";
import AuthImage from "../AuthImage/AuthImage";
import Button from "../button/Button";
import Language from "../common/language";
import StickyFooter from "../StickyFooter/StickyFooter";
import siteConfig from "./../../config/site-config";
import "./static/Header.scss";
import BookCartIcon from "./static/img/BookCartIcon.svg";
import CartIcon from "./static/img/CartIcon.svg";
import userSwitch from "./static/img/user-switch.svg";

const Header = (props) => {
    const searchData = useSelector((state) => state.courseReducer.searchParam);
    const [loginSidebar, setLoginSidebar] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [pageLoader, setPageLoader] = useState(false);
    const getUserData = useSelector((state) => state.userReducer.sessionData);
    const getProfileData = useSelector((state) => state.userReducer.profileData);
    const foundRole = useSelector((state) => state.userReducer.currentRole);
    const [contentBlock, setContentBlock] = useState("");
    const [role, setRole] = useState(foundRole !== null ? foundRole : siteConfig.userRoles[0]);
    let isLoggedIn = JSON.parse(localStorage.getItem(userData));
    const dispatch = useDispatch();
    const [currentRole, setCurrentRole] = useState(foundRole);
    const [userProfileData, setUserProfileData] = useState({});
    const [stickyClass, setStickyClass] = useState("relative");
    const [courseName, setCourseName] = useState("");
    const [totalCartItem, setTotalCartItem] = useState(Number(localStorage.getItem("totalCartItem")));
    const cartCount = useSelector((state) => state.cartReducer.cartCount);
    const bookCartCount = useSelector((state) => state.bookCartReducer.bookCartCount);
    const [isPublishingRoute, setIsPublishingRoute] = useState(false);
    const [noticeList, setNoticeList] = useState([]);
    const [noticeListLoading, setNoticeListLoading] = useState(false);
    const [errorMessageCourseName, setErrorMessageCourseSearch] = useState({
        show: false,
        message: "Name length should be at least 3",
    });
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
    const [mobileScreen, setMobileScreen] = useState(window.innerWidth <= 991.98);

    console.log("bookcart data", bookCartCount);

    useEffect(() => {
        getNoticeBackList();
        getContactUsData();
    }, [])

    useEffect(() => {
        if (isLoggedIn?.userId && isPublishingRoute) {
            fetchCartItems();
        }
    }, [isPublishingRoute]);

    const fetchCartItems = async () => {
        await AxiosServices.get(ApiUrlServices.GET_BOOK_CART_DATA(isLoggedIn.userId))
            .then((res) => {
                const data = res?.data?.data?.items || [];
                const totalCount = data?.reduce((acc, item) => acc + item.ordered_quantity, 0) || 0;
                dispatch(bookCartAction.setBookCartValue(totalCount));
            })
            .catch(() => {
                toast.error("Failed to load cart items");
            })
            .finally(() => { });
    };

    useEffect(() => {
        setCurrentRole(foundRole);
    }, [foundRole]);

    useEffect(() => {
        if (props.cartCountIncrement) {
            setTotalCartItem(totalCartItem + 1);
            localStorage.setItem("totalCartItem", JSON.stringify(totalCartItem + 1));
        }
    }, [props.cartCountIncrement]);

    useEffect(() => {
        if (typeof props.data?.totalCartItem !== typeof undefined) {
            setTotalCartItem(props.data.totalCartItem);
            localStorage.setItem("totalCartItem", props.data.totalCartItem);
        }
    }, [props]);

    useEffect(() => {
        console.log("COURSENAME::: ", courseName);
    }, [courseName]);
    useEffect(() => {
        setCourseName(searchData);
    }, [searchData]);

    // Sticky
    useEffect(() => {
        window.addEventListener("scroll", stickNavbar);
        return () => {
            window.removeEventListener("scroll", stickNavbar);
        };
    }, []);
    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            windowHeight > 150 ? setStickyClass("sticky-header") : setStickyClass("relative");
        }
    };

    // Logged User Profile Data
    useEffect(() => {
        if (isLoggedIn) {
            setPageLoader(true);
            const userDataId = JSON.parse(localStorage.getItem(userData));
            AxiosServices.get(ApiUrlServices.USER_DETAILS + userDataId.userId)
                .then((response) => {
                    dispatch(userAction.setProfileData(response.data.data));
                    const userInfo = response.data.data;
                    setUserProfileData(userInfo);
                    setPageLoader(false);
                })
                .catch((err) => {
                    dispatch(userAction?.resetProfileData(err?.data?.data));
                    toast.error(`${t("ALL_MESSAGE.something_went_wrong")}`);
                    setPageLoader(false);
                });
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            if (getProfileData?.role) {
                if (getProfileData?.role.length === 7 && !getProfileData?.isMentorApprovalPending) {
                    setContentBlock("block1");
                } else if (getProfileData?.role.length === 7 && getProfileData?.isMentorApprovalPending) {
                    setContentBlock("block2");
                }
            }
        }
    }, [getProfileData]);

    function logOut(e) {
        setPageLoader(true);
        e.preventDefault();
        dispatch(cartAction.setCartValue(0));
        dispatch(userAction.setRole("Student"));
        let language = localStorage.getItem("i18nextLng");
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem("i18nextLng", language);

        if (getUserData["signinSource"] === "REGULAR") {
            let payload = {
                accessToken: getUserData?.accessToken,
            };
            document.cookie.split(";").forEach(function (c) {
                document.cookie = c
                    .replace(/^ +/, "")
                    .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            AxiosServices.post(ApiUrlServices.SIGN_OUT, payload, false)
                .then((response) => {
                    dispatch(userAction.resetSessionData());
                    dispatch(userAction.resetProfileData());
                    console.log(response);
                    setPageLoader(false);
                    navigate(path.home);
                })
                .catch((error) => {
                    console.log("logout error", error);
                    setPageLoader(false);
                    navigate(path.home);
                    // toast.error(`${t('ALL_MESSAGE.something_went_wrong')}`)
                });
        } else {
            if (getUserData["signinSource"] === "AUTH0") {
                window.location.href =
                    social_api_base_url +
                    `/logout?client_id=` +
                    cognito_app_client_id +
                    `&logout_uri=` +
                    api_base_url +
                    `/auth/authentication/linkedin-logout/` +
                    auth0_app_client_id +
                    `/` +
                    auth0_redirected_endpoint +
                    `/`;
            } else {
                window.location.href =
                    social_api_base_url +
                    `/logout?client_id=` +
                    cognito_app_client_id +
                    `&logout_uri=` +
                    web_base_url +
                    path.home;
            }
        }
    }

    const clickHandler = (e, name) => {
        e.preventDefault();
        setRole(name);
        dispatch(userAction.setRole(name));
    };

    useEffect(() => {
        const userDataId = JSON.parse(localStorage.getItem(userData))?.userId;
        if (userDataId) {
            getTotalCartItem(userDataId);
        }
        // Check if current route is under publishing
        const currentPath = window.location.pathname;
        setIsPublishingRoute(currentPath.includes("/publishing"));
    }, [window.location.pathname]);

    const getTotalCartItem = (user_id) => {
        AxiosServices.get(ApiUrlServices.COUNT_CART_ITEM(user_id))
            .then((res) => {
                setTotalCartItem(res.data.data.cart_count || 0);
                localStorage.setItem("totalCartItem", res.data.data.cart_count);
                dispatch(cartAction.setCartValue(res.data.data.cart_count || 0));
            })
            .catch((err) => {
                console.log(err);
            });
    };

    function reportWindowSize() {
        window.innerWidth <= 991.98 ? setMobileScreen(true) : setMobileScreen(false);
    }

    window.addEventListener("resize", reportWindowSize);

    const getNoticeBackList = () => {
        setNoticeListLoading(true);
        // debugger
        const finalPayload = {
            page: 1,
            limit: 500,
            type: 'notice'
        };
        AxiosServices.get(ApiUrlServices.FEEDBACK_LIST, finalPayload)
            .then((response) => {
                const publishedStatus = response.data.data.news.filter(item =>
                    item.status === "published").map((item) => item.description)
                setNoticeList(publishedStatus);
                setNoticeListLoading(false);
                console.log(publishedStatus)
            })
            .catch((error) => {
                console.log(error);
                setNoticeListLoading(false);
            });
    }

    const getContactUsData = () => {
        // debugger
        const finalPayload = {
            page: 1,
            limit: 500,
            type: 'contact-us'
        };
        AxiosServices.get(ApiUrlServices.FEEDBACK_LIST, finalPayload)
            .then((response) => {
                dispatch(userAction.setContactData(response.data.data.news[0]));
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <>
            <header className={`header ${stickyClass}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-2 col-lg-1 col-4 align-self-center pr-0-mobile">
                            <div className="h-logo">
                                <Link to={`${process.env.PUBLIC_URL}${path.home}`}>
                                    <img src={siteConfig.company_logo} alt={siteConfig.company_name} />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-10 col-lg-11 col-8">
                            <div className="header-menu-full">
                                {/* <div
                                    className={`${
                                        mobileSearchOpen ? "header-cate-search active" : "header-cate-search"
                                    }`}
                                >
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            if (courseName.length >= 3 || courseName.length === 0) {
                                                dispatch(courseAction.setSearchParam(courseName));
                                                navigate(path.courses_new + "?page=1");
                                                // setCourseName("")
                                            } else {
                                                setErrorMessageCourseSearch((prev) => {
                                                    return {
                                                        ...prev,
                                                        show: true,
                                                    };
                                                });
                                            }
                                        }}
                                    >
                                        <div className="search-from">
                                            <input
                                                value={courseName}
                                                onChange={(e) => {
                                                    setCourseName(e.target.value.replace(/\s{2,}/g, " "));
                                                    if (
                                                        errorMessageCourseName.show &&
                                                        e.target.value.length < 3 &&
                                                        e.target.value.length !== 0
                                                    ) {
                                                        setErrorMessageCourseSearch((prev) => {
                                                            return {
                                                                ...prev,
                                                                show: true,
                                                            };
                                                        });
                                                    } else {
                                                        setErrorMessageCourseSearch((prev) => {
                                                            return {
                                                                ...prev,
                                                                show: false,
                                                            };
                                                        });
                                                    }
                                                }}
                                                placeholder={t("header.search")}
                                                type="text"
                                            />
                                            <i className="bi bi-search" />
                                        </div>
                                    </form>
                                </div> */}
                                <div className={"nav-menu"}>
                                    <ul>
                                        <li className="hide-1200"><NavLink to={`${process.env.PUBLIC_URL}${path.home}`}>{t('header.home')}</NavLink></li>
                                        {/* <li className="hide-1200"><NavLink to={`${process.env.PUBLIC_URL}${path.all_session_list}?page=1`}>{t('header.all_session')}</NavLink></li> */}
                                        <li className="">
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.about}`}>
                                                {t("header.about_us")}
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.courses_new + "?page=1"}`}>
                                                {t("header.courses")}{" "}
                                            </NavLink>
                                        </li>
                                        <li className="hide-1200">
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.instructors}`}>
                                                {t("header.instructor")}{" "}
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to={`${process.env.PUBLIC_URL}${path.publishing_books + "?page=1"}`}
                                            >
                                                {t("header.books")}{" "}
                                            </NavLink>
                                        </li>
                                        {/* <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.donation}`}>
                                                {t("header.donation")}{" "}
                                            </NavLink>
                                        </li> */}
                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.blog + "?page=1"}`}>
                                                {t("header.blog")}{" "}
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.gallery}`}>
                                                {t("header.gallery")}{" "}
                                            </NavLink>
                                        </li>
                                        {/* <li className="hide-1200 header-user-dropdwon">
                                            <span>{t("header.content")}</span>
                                            <i className="bi bi-chevron-down" />
                                            <ul>
                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}${path.events + "?page=1"}`}>
                                                        {t("header.events")}{" "}
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}${path.news + "?page=1"}`}>
                                                        {t("header.news")}{" "}
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink
                                                        to={`${process.env.PUBLIC_URL}${path.article + "?page=1"}`}
                                                    >
                                                        {t("header.article")}{" "}
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}${path.blog + "?page=1"}`}>
                                                        {t("header.blog")}{" "}
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li> */}
                                        <li>
                                            <NavLink to={`${process.env.PUBLIC_URL}${path.contact}`}>
                                                {t("header.contact_us")}{" "}
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className="header-right">
                                    <div
                                        className="mobile-search-icon"
                                        onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
                                    >
                                        <i className={`${mobileSearchOpen ? "bi bi-x-lg" : "bi bi-search"}`} />
                                    </div>
                                    {isPublishingRoute ? (
                                        <Link
                                            to={
                                                isLoggedIn
                                                    ? `${process.env.PUBLIC_URL}${path.book_cart}`
                                                    : `${process.env.PUBLIC_URL}${path.login}`
                                            }
                                            className="header-cart-icon"
                                        >
                                            <img src={BookCartIcon} alt="BookCartIcon" />
                                            {bookCartCount > 0 && isLoggedIn && (
                                                <span className="count-num">
                                                    {bookCartCount > 0
                                                        ? `${t("number_translate", {
                                                            count: returnNumberByLang(bookCartCount),
                                                        })}`
                                                        : `${t("number_translate", { count: returnNumberByLang(0) })}`}
                                                </span>
                                            )}
                                        </Link>
                                    ) : (
                                        <Link to={`${process.env.PUBLIC_URL}${path.cart}`} className="header-cart-icon">
                                            <img src={CartIcon} alt="CartIcon" />
                                            {cartCount > 0 && isLoggedIn && (
                                                <span className="count-num">
                                                    {cartCount > 0
                                                        ? `${t("number_translate", {
                                                            count: returnNumberByLang(cartCount),
                                                        })}`
                                                        : `${t("number_translate", { count: returnNumberByLang(0) })}`}
                                                </span>
                                            )}
                                        </Link>
                                    )}
                                    <Language />
                                    {isLoggedIn ? (
                                        <div className="header-user-dropdwon">
                                            {getProfileData?.profile_picture ? (
                                                <img
                                                    src={`${cloudfront_base_url}${getProfileData?.profile_picture}`}
                                                    alt={getProfileData?.name}
                                                    className="user_img"
                                                />
                                            ) : (
                                                <img
                                                    src={siteConfig.default_avatar}
                                                    alt={getProfileData?.name}
                                                    className="user_img"
                                                />
                                            )}

                                            <div className="dropdwon-list-user">
                                                <div className="h-header">
                                                    <div className="img">
                                                        {getProfileData?.profile_picture ? (
                                                            <img
                                                                src={`${cloudfront_base_url}${getProfileData?.profile_picture}`}
                                                                alt={getProfileData?.name}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={siteConfig.default_avatar}
                                                                alt={getProfileData?.name}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="con">
                                                        <h4>{getProfileData?.name}</h4>
                                                        {currentRole === "Student" ? (
                                                            <span>{t("header.student")}</span>
                                                        ) : (
                                                            <span>{t("header.instructor")}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <ul>
                                                    <li>
                                                        <Link to={`${process.env.PUBLIC_URL}${path.view_profile}`}>
                                                            <i className="fa-regular fa-user" />{" "}
                                                            <span>{t("header.my_account")}</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to={`${process.env.PUBLIC_URL}${path.payment_history}?page=1`}
                                                        >
                                                            <i className="fa-solid fa-suitcase-rolling" />{" "}
                                                            <span>{t("header.my_order")}</span>
                                                        </Link>
                                                    </li>
                                                    {/* apply as instructor  */}

                                                    {/* {contentBlock === "block1" ? (
                                                        <li className="active">
                                                            <Link
                                                                to={`${process.env.PUBLIC_URL}${path.view_profile}#instructorApply`}
                                                            >
                                                                <i className="fa-solid fa-user-plus" />
                                                                <span>{t("header.apply_as_instructor")}</span>
                                                            </Link>
                                                        </li>
                                                    ) : null} */}
                                                    {contentBlock === "block2" ? (
                                                        <li className="active disabled">
                                                            <a>
                                                                <i className="fa-solid fa-user-plus" />{" "}
                                                                <span style={{ fontSize: "14px" }}>
                                                                    {t("header.pending_instructor_approval")}
                                                                </span>
                                                            </a>
                                                        </li>
                                                    ) : null}

                                                    {getProfileData?.isMentorApproved === true ? (
                                                        <>
                                                            {currentRole === "Student" ? (
                                                                <li className="active">
                                                                    <a
                                                                        onClick={(e) =>
                                                                            clickHandler(e, siteConfig.userRoles[1])
                                                                        }
                                                                    >
                                                                        <img src={userSwitch} alt={"User Switch"} />
                                                                        {/*<i className="fa-solid fa-user-plus"/>*/}
                                                                        <span>{t("header.switch_to_instructor")}</span>
                                                                    </a>
                                                                </li>
                                                            ) : (
                                                                <li className="active">
                                                                    <a
                                                                        onClick={(e) =>
                                                                            clickHandler(e, siteConfig.userRoles[0])
                                                                        }
                                                                    >
                                                                        {/*<i className="fa-solid fa-user-plus"/> */}
                                                                        <img src={userSwitch} alt={"User Switch"} />
                                                                        <span>{t("header.switch_to_student")}</span>
                                                                    </a>
                                                                </li>
                                                            )}
                                                        </>
                                                    ) : null}
                                                    {currentRole === "Student" ? (
                                                        <li>
                                                            <Link
                                                                to={`${process.env.PUBLIC_URL}${path.view_profile_course}?page=1`}
                                                            >
                                                                <i className="fa-solid fa-book" />{" "}
                                                                {t("profile_header.my_courses")}
                                                            </Link>
                                                        </li>
                                                    ) : (
                                                        <li>
                                                            <Link
                                                                to={`${process.env.PUBLIC_URL}${path.view_instructor_course}?page=1`}
                                                            >
                                                                <i className="fa-solid fa-book" />{" "}
                                                                {t("profile_header.own_course")}
                                                            </Link>
                                                        </li>
                                                    )}
                                                    <li>
                                                        <Link to={`${process.env.PUBLIC_URL}${path.wishlist}?page=1`}>
                                                            <i className="fa-regular fa-heart" />{" "}
                                                            <span>{t("header.wishlist")}</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${process.env.PUBLIC_URL}${path.contact}`}>
                                                            <i className="fa-regular fa-life-ring" />{" "}
                                                            <span>{t("header.help")}</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <a onClick={logOut} href={void 0}>
                                                            <i className="fa-solid fa-right-from-bracket" />{" "}
                                                            <span>{t("header.logout")}</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <Button
                                                btnText={
                                                    mobileScreen
                                                        ? `${t("header.login")}`
                                                        : `${t("header.login_signup")}`
                                                }
                                                btnClassName="login-signup"
                                                onclickCallback={() => setLoginSidebar(!loginSidebar)}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {
                noticeList.length > 0 &&
                <div class="marquee-container">
                    <div class="marquee-content">
                        {
                            noticeList.map((item) => <span className="me-2">{item}</span>)
                        }
                    </div>
                </div>
            }
            {/* Login Register  */}
            <div className={loginSidebar ? "section-sidebar-login active" : "section-sidebar-login"}>
                <div className="section-sidebar-login-header">
                    <div className="back-btn" onClick={() => setLoginSidebar(!loginSidebar)}>
                        <i className="bi bi-chevron-left" />
                    </div>
                    <div className="title">
                        <strong>{t("header.login_signup")}</strong>
                    </div>
                </div>
                <div className="section-sidebar-login-img">
                    <AuthImage />
                </div>
                <div className="section-sidebar-login-from">
                    <Login loginSidebar={loginSidebar} setLoginSidebar={setLoginSidebar} />
                </div>
            </div>
            <div className={loginSidebar ? "off_canvars_overlay active" : "off_canvars_overlay"} />
            {mobileScreen ? <StickyFooter /> : null}
        </>
    );
};
export default Header;
